import types from './types';

const actions = {
  [types.TOGGLE_AUTH_PAGE]({
    state,
  }, flag) {
    state.isAuthPage = flag;
  },
  [types.ON_ROUTE_CHANGE]({
    state,
  }, route) {
    state.isAuthPage = !!route.meta.authPage;
    state.isLoginPage = !!route.meta.isLoginPage;
    state.isRegisterPage = !!route.meta.isRegisterPage;
    state.isForgotPasswordPage = !!route.meta.isForgotPasswordPage;
  },
};

export default actions;
